import { makeStyles, createStyles } from "@material-ui/core";
import { colorUtil } from "../../util/ColorUtil";

const useStyles = makeStyles(() =>
  createStyles({
    errorTooltipWraper: {
      position: "absolute",
      bottom: "-8.5px",
      left: "12px",
    },
    errorTooltip: {
      position: "relative",
      top: 0,
      display: "flex",
      alignItems: "center",
      width: "max-content",
      backgroundColor: `${colorUtil.red60}`,
      fontSize: "12px",
      padding: "2px",
      borderRadius: "2px",
      "&::before": {
        content: "''",
        display: "block",
        width: 0,
        height: 0,
        position: "absolute",
        border: "3px solid transparent",
        borderBottom: `4px solid ${colorUtil.red60}`,
        left: "6px",
        bottom: "100%",
        top: "-7px",
        right: 0,
      },
    },
    errorTooltipMessage: {
      color: "white",
      fontSize: "11px",
      flex: 1,
      paddingLeft: "4px",
    },
  })
);

export const ErrorTooltip = (props: { children: React.ReactChild }) => {
  const classes = useStyles();
  const { children } = props;
  return (
    <div className={classes.errorTooltipWraper}>
      <div className={classes.errorTooltip}>
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          transform="scale(1)"
        >
          <circle cx="12" cy="12" r="10" fill={`${colorUtil.red80}`} />
          <rect
            width="2"
            height="8"
            transform="matrix(-1 0 0 1 13 6)"
            fill={`${colorUtil.white}`}
          />
          <rect
            x="11"
            y="16"
            width="2"
            height="2"
            fill={`${colorUtil.white}`}
          />
        </svg>
        <div className={classes.errorTooltipMessage}>{children}</div>
      </div>
    </div>
  );
};
